import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import MediaQueries, {breakpoint} from '~/constants/MediaQueries';
import {FUNDRAISING_PHONE_NUMBER} from '~/constants/ContactConstants';
import {ttarpIcon} from '~/constants/InlineSvgs';
import {LIVE_ENGAGE_DESKTOP} from '~/constants/LiveEngage';
import {forceChatParse} from '~/utils/gtmInjected';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {Link} from '@customink/pigment-react';
import {pushGtmEvent} from '~/utils/analytics';
import Cookies from 'cookies-js';

import './index.scss';

const _ttarp_test_opts = {
  test: {
    COPY: '855‑227‑1676',
    TEL_LINK: 'tel:+18552271676'
  },
  control: {
    COPY: '855‑226‑6256',
    TEL_LINK: 'tel:+185552266256'
  },
  excluded: {
    COPY: '855‑563‑7465',
    TEL_LINK: 'tel:+18555637465'
  }
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function Ttarp({isFundraisingMode, onChatClick}) {
  const ttarpTestValue = Cookies.get('feature_ttarp_header_v3') || 'excluded';
  const supportPhoneNumber = _ttarp_test_opts[ttarpTestValue];

  const phoneNumber = isFundraisingMode
    ? FUNDRAISING_PHONE_NUMBER
    : supportPhoneNumber;

  useEffect(() => {
    forceChatParse();
    pushGtmEvent({
      event: 'ttarp_number_shown',
      ttarp_value: phoneNumber.COPY
    });
  }, [phoneNumber.COPY]);

  const handleCallClick = e => {
    e.preventDefault();
    pushGtmEvent({
      event: 'lab_nav',
      click_section: 'ttarp',
      click_link: `ttarp ${ttarpTestValue} link`
    });
    window.location.href = e.currentTarget.href;
  };

  const handleChatClick = e => {
    e.preventDefault();
    pushGtmEvent({
      event: 'lab_nav',
      click_section: 'chat',
      click_link: `chat ${ttarpTestValue} link`
    });
    onChatClick();
  };

  if (!breakpoint(MediaQueries.mediumAndAbove)) {
    return null;
  }

  return (
    <div className="ndx-Ttarp">
      <div className="ndx-Ttarp-section ndx-Ttarp-talkSection">
        <div
          className="ndx-Ttarp-icon"
          dangerouslySetInnerHTML={renderInlineSvg(ttarpIcon)}
        />
        <div className="ndx-Ttarp-textWrapper">
          <div className="ndx-Ttarp-text">Talk to a Real Person</div>
          <div className="ndx-Ttarp-cta">
            <Link href={phoneNumber.TEL_LINK} onClick={handleCallClick}>
              {phoneNumber.COPY}
            </Link>
          </div>
        </div>
      </div>
      <div
        className="ndx-TtarpRebrand-section"
        id={LIVE_ENGAGE_DESKTOP}
        onClick={handleChatClick}
      />
    </div>
  );
}

const propTypes = {
  isFundraisingMode: PropTypes.bool,
  onChatClick: PropTypes.func
};

Ttarp.propTypes = propTypes;
